import { Get, Set } from "../../../../../Request";
const user = JSON.parse(localStorage.getItem('user'));

export const FormSubmit = async (data,isUser) => {
  return await Get({
    url: isUser ? "/withdraw/user_request_step_one" : "/withdraw/request_step_one",
    data: data,
    stat: true,
  }).then(data => {
    return data;
  });
};
export const GetData = async () => {
  return await Get({
    url: "/wallet/show",
  }).then(data => {
    return data;
  });
};
export const GetRequest = async (isUser) => {
  if (isUser) {
    return await Get({
      url: "/withdraw/user_get_status",
      data: { user_id: user.id }
    }).then(data => {
      return data;
    });
  }

  return await Get({
    url: "/withdraw/get_status",

  }).then(data => {
    return data;
  });

};
export const getUserList = async () => {
  return await Get({
    url: "/withdraw/user_list",

  }).then(data => {
    return data;
  });
};
export const SubmitCode = async (data,isUser) => {
  return await Get({
    url: isUser ? "/withdraw/user_request_step_two" : "/withdraw/request_step_two",
    data,
    stat: true,
  }).then(data => {
    return data;
  });
};
